import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { developersCacheKey } from "./constants";
import type { Developer } from "./types";

/**
 * Get the latest developer information.
 */
export const getDevelopers = reactQueryFetcherAdapter(
  developersCacheKey,
  async (signal, companyId: string): Promise<Developer[]> => {
    return fetch(`/companies/${companyId}/developers`, "GET", undefined, { signal });
  }
);
